import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import i18next from "i18next";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import {getSubFinanceEmailsLink} from "../../../actions/subFinanceActions";
import isEqual from 'lodash/isEqual';

class SubFinanceEmail extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedRowKeys: [],
            showAllRows: false
        };
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.dataItem.execute({}, {withParams: true}));
        } catch (e) {
            console.error(e);
        }
    }

    getDocument = async (event, row) => {
        if (event) event.preventDefault();
        const rowKey = this.props.dataItem.getRowKey(row);
        await this.getSelectedDocuments(event, [rowKey]);
    }

    getSelectedDocuments = async (event, rowKeys) => {
        if (event) event.preventDefault();
        await this.props.dispatch(getSubFinanceEmailsLink(this.props.controller, rowKeys));
        if(this.props.fileLink) {
            const token = await AuthProvider.getToken();
            const downloadPath = pathJoin(window.config.apiRoot, this.props.fileLink) + "&" + $.param({
                b_token: token
            });
            window.open(downloadPath, '_blank');
        }
    }

    isCanDownLoad = (row) => {
        return /*true || */row._IsCanDownLoad === 1;
    }
    renderCellEx = (cellParams) => {
        if (cellParams.fieldInfo.Name === "RowActions" &&  this.isCanDownLoad(cellParams.row)) {
            return (
                <div>
                    <label>
                        <a href="" rel="noopener noreferrer"
                           onClick={(event) => this.getDocument(event, cellParams.row)}
                           className="mr-2">{i18next.t("Download")}</a>
                    </label>
                </div>);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }

    cellClick = (row, fieldInfo, e) => {
        if (fieldInfo.Name !== 'RowActions') {
            if (this.isCanDownLoad(row)) {
                this.setState((state, props) => {
                    let newSelectedRowKeys;
                    const rowKey = this.props.dataItem.getRowKey(row);
                    if (row.IsChecked === 0) {
                        newSelectedRowKeys = [...state.selectedRowKeys];
                        newSelectedRowKeys.push(rowKey);
                    } else {
                        newSelectedRowKeys = state.selectedRowKeys.filter(rk => !isEqual(rk, rowKey));
                    }
                    return {
                        selectedRowKeys: newSelectedRowKeys
                    };
                });
            }
        }
    }
    clearSelectedPersons = () => {
        this.setState({selectedRowKeys: []});
    }
    selectAllPersons = async () => {
        const rowKeys = this.props.dataItem.dataTable().filter(row => this.isCanDownLoad(row)).map(row => this.props.dataItem.getRowKey(row));
        this.setState({selectedRowKeys: rowKeys});
    }
    renderPersonRow = (row, rowIndex, renderRowDefault) => {
        let rRow = {
            ...row,
            IsChecked: this.state.selectedRowKeys.some(rowKey => isEqual(rowKey, this.props.dataItem.getRowKey(row))) ? 1 : 0,
        };
        return renderRowDefault(rRow, rowIndex);
    }

    renderButtons = () => {
        const selectableRows = this.props.dataItem.dataTable().filter(row => this.isCanDownLoad(row));
        return (<div className="modal-footer text-right btn-group">
            {this.props.dataItem.isInitialized && this.props.dataItem.rowsCount() > 0 && <>
                <button type="button" className="btn btn-regular -godefault ml1ex"
                        data-dismiss="modal" onClick={() => {
                    this.setState({showAllRows: !this.state.showAllRows});
                }}>{i18next.t((this.state.showAllRows ? "Show_By_Pages" : "Show_All"))}</button>
                {selectableRows && selectableRows.length > 0 &&
                <button type="button" className="btn btn-regular -godefault ml1ex"
                        data-dismiss="modal" onClick={this.selectAllPersons}>{i18next.t("Select_All")}</button>}
            </>}
            {this.state.selectedRowKeys && this.state.selectedRowKeys.length > 0 && <>
                <button type="button" className="btn btn-regular -goescape ml1ex"
                        data-dismiss="modal"
                        onClick={this.clearSelectedPersons}>{i18next.t("Cancel_All_Selected")}</button>
                <button type="button" className="btn btn-regular ml1ex"
                        data-dismiss="modal"
                        onClick={(event) => this.getSelectedDocuments(event, this.state.selectedRowKeys)}>{i18next.t("Download_All_Selected")}</button>
            </>}
        </div>)
    }
    gridRowStyleProvider = (rowIndex, row) => {
        let style =  this.isCanDownLoad(row) && {cursor: "pointer"};
        if (row.IsChecked === 1 &&  this.isCanDownLoad(row)) {
            return {
                ...style, fontWeight: "bold", backgroundColor: "lightgrey"
            };
        }
        return style;
    }
    selectSubgridRow = async (e, rowParams) => {
        if (e) e.preventDefault();
        await this.props.dispatch(rowParams.dataItem.setField(rowParams.rowIndex, 'IsInSet', (rowParams.row.IsInSet === 1 ? 0 : 1)));
        await this.props.dispatch(rowParams.dataItem.save(rowParams.rowIndex));
    }
    renderSubgridRowEx = (rowParams) => {
        return (<div style={{cursor: "pointer"}} key={rowParams.rowIndex}
                     onClick={(e) => this.selectSubgridRow(e, rowParams)}>
            <input type="checkbox" className="checkbox" checked={rowParams.row.IsInSet === 1}
                   style={{cursor: "pointer"}} onChange={() => {
            }}/>&nbsp;
            {(rowParams.dataItem.rawData.ItemId.endsWith('POx_PersReptLookAds') ? rowParams.row.AdmStructTitle : null)}
        </div>)
    }
    render() {
        if (!this.props.dataItem.isInitialized)
            return null;
        const title = i18next.t(this.props.controller === 'AnnualBonusEmail' ? "Sub_Finance_Email_1" : "Sub_Finance_Email_2");
        return (
            <PlaceholderWrapper placeholderId="10"
                                title={<><i
                                    className='fa fa-money-bill-alt'/> {i18next.t(title)}</>}
                                showSplitterLine={true} canCollapse={false}>
                <PlaceholderWrapper placeholderId="20"
                                    title={<><i className='fa fa-filter'/> {i18next.t('Filters')}</>}
                                    showSplitterLine={false} collapsed={true}
                >
                    <ComplexParam parentDataItem={this.props.dataItem}
                                  dataItem={this.props.dataItem_Params}
                                  renderParams={paramRender}
                                  showApplyButton={false} autoApplyParams={true}
                                  showSubgridHeader={false}
                                  renderSubgridRowEx={this.renderSubgridRowEx}
                                  maxSubgridWidthBody=""
                                  afterApplyParams={() => {
                                      this.setState({selectedRowKeys: []})
                                  }}
                                  readOnly={false} showSearchBar={false}
                                  rootPath="/"/>
                </PlaceholderWrapper>
                <PlaceholderWrapper placeholderId="20"
                                    title={<><i className='fa fa-table'/> {i18next.t("Employees")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    {this.renderButtons()}
                    <GridView dataItem={this.props.dataItem} renderCellEx={this.renderCellEx}
                              onCellClick={this.cellClick}
                              allowPagination={!this.state.showAllRows}
                              pageSize={5} activePageSize={5}
                              renderRow={this.renderPersonRow}
                              updateStateFlag={{f: this.state.selectedRowKeys}}
                              rowStyleProvider={this.gridRowStyleProvider}/>
                </PlaceholderWrapper>
            </PlaceholderWrapper>
        )
    }
}

SubFinanceEmail.propTypes = {
    dispatch: PropTypes.func.isRequired,
    controller: PropTypes.string.isRequired,
    dataItem: PropTypes.object,
    dataItem_Params: PropTypes.object
}

SubFinanceEmail.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: ownProps.controller === 'AnnualBonusEmail' ? state.subFinanceEmailItems.YearBonusRept_POx_PersRept : state.subFinanceEmailItems.SalaryChangeRept_POx_PersRept,
        dataItem_Params: ownProps.controller === 'AnnualBonusEmail' ? state.subFinanceEmailItems.YearBonusRept_POx_PersRept_Params : state.subFinanceEmailItems.SalaryChangeRept_POx_PersRept_Params,
        fileLink: state.subFinanceEmailState.fileLink
    }
}

export default connect(mapStateToProps)(SubFinanceEmail)